import React from 'react'
import styled from 'styled-components'

import TitleHeader from 'components/presenters/header/TitleHeader'

export default function PointUse() {
  return (
    <PointUseWrapper>
      <TitleHeader title={'포인트로 제품 구매하기'} isCloseBtn/>

      <PointUseFormBlock>
        <iframe
          title="point use form"
          src="https://walla.my/survey/vfBVBjM0iBRCPso7rnvC"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        ></iframe>
      </PointUseFormBlock>
    </PointUseWrapper>
  )
}

const PointUseWrapper = styled.div`
  height: 100vh;
  overflow: hidden;
`

const PointUseFormBlock = styled.div`
  padding-top: calc(100vw * (51 / 375));
  height: 100%;
`
